import { useId } from "react";

import { cn } from "@/lib/utils";
import { JobLiquidity } from "@/types";

// Fill height (of the 24-unit viewBox) per level — the droplet reads as a
// gauge: empty outline for Low, brimming for Very High.
const fillHeightByLevel: Record<JobLiquidity, number> = {
  [JobLiquidity.UNKNOWN]: 0,
  [JobLiquidity.THIN]: 0,
  [JobLiquidity.MODERATE]: 6,
  [JobLiquidity.LIQUID]: 12,
  [JobLiquidity.VERY_LIQUID]: 24,
};

export const LiquidityDroplet = ({
  className,
  level,
}: {
  className?: string;
  level: JobLiquidity;
}) => {
  /* React Hooks */
  const fillClipId = useId();

  /* Render */
  const render = () => {
    const fillHeight = fillHeightByLevel[level];
    const isUnknown = level === JobLiquidity.UNKNOWN;

    return (
      <svg className={cn("h-5 w-5", className)} viewBox="0 0 24 24">
        <defs>
          <clipPath id={fillClipId}>
            <rect height={fillHeight} width="24" x="0" y={24 - fillHeight} />
          </clipPath>
        </defs>
        <path
          className={
            fillHeight > 0 ? "fill-lever-icon-information" : "fill-transparent"
          }
          clipPath={`url(#${fillClipId})`}
          d="M12 2.5 7.5 9.4C5.9 11.8 5 13.6 5 15.5a7 7 0 0 0 14 0c0-1.9-.9-3.7-2.5-6.1L12 2.5Z"
        />
        <path
          className={cn(
            "fill-none",
            isUnknown
              ? "stroke-lever-border-light"
              : "stroke-lever-border-information",
          )}
          d="M12 2.5 7.5 9.4C5.9 11.8 5 13.6 5 15.5a7 7 0 0 0 14 0c0-1.9-.9-3.7-2.5-6.1L12 2.5Z"
          strokeDasharray={isUnknown ? "2 3" : undefined}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    );
  };

  return render();
};
